import { useState } from "react";
import { notification } from "antd";
import { useDispatch } from "react-redux";

import "../../src/style/login.css";
import { setAdminLoggedTrigger } from "../redux/actions/mainAction";
const Login = () => {
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [eyeClass, setEyeClass] = useState("far fa-eye-slash");

  const [api, contextHolder] = notification.useNotification();

  const dispatch = useDispatch();

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "E-poçt və Şifrə vacib sahələrdir!",
    });
  };

  const openNotificationWrongEmailPass = (type) => {
    api[type]({
      message: "E-poçt və ya Şifrə səhvdir!",
    });
  };

  const openNotificationNotAdmin = (type) => {
    api[type]({
      message: "Təəssüf ki, siz Admin deyilsiniz!",
    });
  };

  const loginHandler = async () => {
    if (employeeEmail && password) {
      let result = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
        method: "post",
        body: JSON.stringify({
          employeeEmail,
          password,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      result = await result.json();

      if (result.result === "You are not Admin") {
        openNotificationNotAdmin("error");
      } else {
        if (result.accessToken) {
          localStorage.setItem("user", JSON.stringify(result.user));
          localStorage.setItem("token", JSON.stringify(result.accessToken));
          localStorage.setItem(
            "refreshToken",
            JSON.stringify(result.refreshToken)
          );

          dispatch(setAdminLoggedTrigger(Math.random()));
        } else {
          openNotificationWrongEmailPass("error");
        }
      }
    } else {
      openNotificationWithIcon("error");
    }
  };

  const changeType = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
    setEyeClass(
      eyeClass === "far fa-eye-slash" ? " far fa-eye" : "far fa-eye-slash"
    );
  };
  return (
    <>
      {contextHolder}
      <div className="login-box">
        <h2>Admin Panel</h2>
        <form>
          <div className="user-box">
            <input
              type="text"
              name=""
              required
              value={employeeEmail}
              onChange={(e) =>
                setEmployeeEmail(e.target.value.toLowerCase().trim())
              }
            />
            <label>E-poçt</label>
          </div>
          <div className="user-box">
            <input
              type={passwordType}
              name=""
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <i
              onClick={changeType}
              className={eyeClass}
              id="togglePassword"
              style={{ marginLeft: -30, cursor: "pointer", color: "white" }}
            ></i>
            <label>Şifrə</label>
          </div>
          <a style={{ cursor: "pointer" }} onClick={loginHandler}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            DAXİL OL
          </a>
        </form>
      </div>
    </>
  );
};

export default Login;
